/*
 * @description:
 * @author: wolfgun
 * @Date: 2020-11-26 23:11:28
 */
import request from '@/utils/request'
import { ADMIN_SERVICE_URL } from '@/utils/constant'
export function list(queryParams) {
  return request({
    url: `${ADMIN_SERVICE_URL}/userDynamic`,
    method: 'get',
    params: queryParams
  })
}


export function getCityOptions(queryParams) {
  return request({
    url: `${ADMIN_SERVICE_URL}/getWorldCityOptions`,
    method: 'get',
    params: queryParams
  })
}
export function getWorldCountryOptions(queryParams) {
  return request({
    url: `${ADMIN_SERVICE_URL}/getWorldCountryOptions`,
    method: 'get',
    params: queryParams
  })
}


export function getSimulationOptions() {
  return request({
    url: `${ADMIN_SERVICE_URL}/userDynamic/getSimulationOptions`,
    method: 'get',
  })
}

export function detail(id) {
  return request({
    url: `${ADMIN_SERVICE_URL}/userDynamic/` + id,
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/userDynamic`,
    method: 'post',
    data: data
  })
}

export function batchDisabled(data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/userDynamic/batchDisabled`,
    method: 'post',
    data: data
  })
}

export function update(id, data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/userDynamic/` + id,
    method: 'put',
    data: data
  })
}

export function del(ids) {
  return request({
    url: `${ADMIN_SERVICE_URL}/userDynamic/` + ids,
    method: 'delete'
  })
}

export function patch(id, data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/userDynamic/` + id,
    method: 'patch',
    data: data
  })
}
